import { Icon } from '@procurify/ui'

interface BillItemTaxOverrideIndicatorIconProps {
  exceedsSubtotal: boolean
  exceedsVariance: boolean
  exceedsSubtotalAriaLabel: string
  exceedsVarianceAriaLabel: string
  defaultAriaLabel: string
}

export const BillItemTaxOverrideIndicatorIcon = ({
  exceedsSubtotal,
  exceedsVariance,
  exceedsSubtotalAriaLabel,
  exceedsVarianceAriaLabel,
  defaultAriaLabel,
}: BillItemTaxOverrideIndicatorIconProps) => {
  if (exceedsSubtotal) {
    return (
      <Icon
        icon='attention'
        color='warning'
        size={12}
        aria-label={exceedsSubtotalAriaLabel}
      />
    )
  }
  if (exceedsVariance) {
    return (
      <Icon
        icon='attention'
        color='warning'
        size={12}
        aria-label={exceedsVarianceAriaLabel}
      />
    )
  }
  return (
    <Icon
      icon='question'
      color='darkGrey'
      size={12}
      aria-label={defaultAriaLabel}
    />
  )
}

BillItemTaxOverrideIndicatorIcon.displayName =
  'BillItemTaxOverrideIndicatorIcon'
